// File: components/OperatingResources.js
import React, { useState } from 'react';
import SummaryBox from './SummaryBox';

const OperatingResources = ({
  operatingResources,
  setOperatingResources,
  operatingResourcesOptions,
  operatingResourcesInfo,
  location,
  applyLocationMultiplier,
  formatCurrency,
  summaryBoxInfo
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const selectedResource = operatingResourcesOptions.find(res => res.name === operatingResources);

  // Prepare summary items
  const getSummaryItems = () => {
    const monthlyCost = selectedResource.costPerMonth;
    const adjustedMonthlyCost = applyLocationMultiplier ? applyLocationMultiplier(monthlyCost) : monthlyCost;
    const annualCost = monthlyCost * 12;
    const adjustedAnnualCost = applyLocationMultiplier ? applyLocationMultiplier(annualCost) : annualCost;

    return [
      {
        label: operatingResourcesInfo.monthlyCostLabel,
        value: formatCurrency(adjustedMonthlyCost),
        type: "cost",
        bold: true
      },
      {
        label: operatingResourcesInfo.annualCostLabel,
        value: formatCurrency(adjustedAnnualCost),
        type: "cost",
        bold: true
      },
      {
        label: operatingResourcesInfo.successModifierLabel,
        value: selectedResource.modifier > 0 ? `+${selectedResource.modifier}%` : `${selectedResource.modifier}%`,
        type: "success",
        bold: true
      }
    ];
  };

  // Helper to display costs with location consideration
  const displayCost = (monthlyAmount) => {
    const annualAmount = monthlyAmount * 12;

    if (location === 'sanfrancisco') {
      const adjustedAnnual = applyLocationMultiplier ? applyLocationMultiplier(annualAmount) : annualAmount;
      return formatCurrency(adjustedAnnual);
    }

    return formatCurrency(annualAmount);
  };

  return (
    <div className="mb-6">
      <div className="flex items-center mb-1">
        <h2 className="text-xl font-semibold">{operatingResourcesInfo.title}</h2>
        <button
          className="ml-2 text-blue-500 text-sm"
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? operatingResourcesInfo.hideDetailsLabel : operatingResourcesInfo.showDetailsLabel}
        </button>
      </div>

      {showDetails && (
        <div className="bg-blue-50 p-3 rounded mb-3 text-sm">
          <p className="mb-2">
            {operatingResourcesOptions.description}
          </p>
          <ul className="list-disc pl-5">
            {operatingResourcesOptions.map((option) => (
              <li key={option.name} className={operatingResources === option.name ? "font-semibold" : ""}>
                <strong>{option.description.split(':')[0]}</strong>: {option.detailedDescription}
                <div className="mt-1">
                  <strong>{operatingResourcesInfo.annualCostLabel2}</strong>{' '}
                  {location === 'sanfrancisco'
                    ? `${formatCurrency(option.costPerMonth * 12)} (${formatCurrency(applyLocationMultiplier(option.costPerMonth * 12))} ${operatingResourcesInfo.inSFText || "in SF"})`
                    : formatCurrency(option.costPerMonth * 12)}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      <select
        value={operatingResources}
        onChange={(e) => setOperatingResources(e.target.value)}
        className="w-full p-2 border rounded"
      >
        {operatingResourcesOptions.map((option) => (
          <option key={option.name} value={option.name}>
            {location === 'sanfrancisco' && option.costPerMonth > 0
              ? `${option.description.split(':')[0]}: ${formatCurrency(applyLocationMultiplier(option.costPerMonth))}${operatingResourcesInfo.perMonthText || "/month"} (${operatingResourcesInfo.sfShortText || "SF"})`
              : option.description}
          </option>
        ))}
      </select>

      {selectedResource && (
        <div className="mt-3">
          <SummaryBox
            title={`${selectedResource.description.split(':')[0]}`}
            description={selectedResource.detailedDescription}
            items={getSummaryItems()}
            summaryBoxInfo={summaryBoxInfo}
          />
        </div>
      )}
    </div>
  );
};

export default OperatingResources;